import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable, Modal } from 'components/basic'
import FlowView from 'components/core/FlowView'
import ReactHtmlParser from 'react-html-parser'
import { date } from 'helpers'
import { Installation } from 'config'
import http from 'API/http'

class TicketOverview extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      searching: false,
      searchQuery: '',
      tickets: [],
      modalState: false,
      loading: true
    }
  }
  async componentDidMount () {
    if (!Installation.enable.ticketsCreate) this.setState({modalState: true})
    var err, res
    [err, res] = await http.get('2.3/tickets/search/' + this.state.searchQuery)
    if (err) return this.setState({tickets: [], searching: false})
    this.setState({tickets: res.data, searching: false, loading: false})
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  getAssignee (assignee) {
    switch (assignee) {
      case 0:
        return 'CO'
      case 1:
        return 'SP'
      default:
        return assignee
    }
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Trouble Tickets' subtitle='Overview' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='commenting-o' title='Tickets'>
            <FlowTable loading={this.state.loading} paginatable={20} data={this.state.tickets.map(res => [{ onClick: e => (window.location.href = '/#/ticket/' + res.ticketRef) }, <a href={'/#/ticket/' + res.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>, res.ticketRef, ReactHtmlParser(res.title), res.spReference, date.format(res.created * 1000), date.format(res.updated * 1000), this.getStatus(res.state.status), (res.assignee ? res.assignee : this.getAssignee(res.state.assignedTo))])}>
              <tr>
                <th className='buttons' />
                <th>ID</th>
                <th>Title</th>
                <th>Reference</th>
                <th>Created</th>
                <th>Last Update</th>
                <th>Status</th>
                <th>Assignee</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
        <Modal title='Ticket Information' isOpen={this.state.modalState} close={e => this.setState({modalState: false})}>
          {ReactHtmlParser(Installation.ticketRules)}
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketOverview = connect(state => state.siteReducer)(TicketOverview)
export default TicketOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/ticket/overview.js